import { defineStyle } from '@chakra-ui/react';

const style = defineStyle({
  root: {
    gap: '20px',
    mb: '40px',
    '.sideBlockSkeleton': {
      w: '100%',
      h: '1px',
    },
    '.singleBlockSkeletonText1': {
      noOfLines: 1,
      w: '170px',
      maxW: '100%',
      mb: '16px',
      mt: '20px',
    },
    '.singleBlockSkeletonText2': {
      noOfLines: 1,
      w: '250px',
      maxW: '100%',
    },
    '.optionContainer': {
      placeItems: 'center',
      gap: '20px',
    },
    '.optionSkeleton': {
      height: '86px',
      width: '100px',
      borderRadius: '10px',
    },
    '.optionSkeletonText': {
      noOfLines: 1,
      w: '100%',
      maxW: '100px',
    },
  },
});

export default style;
